<template>
  <div>
    <!--导航栏 start-->
    <van-nav-bar left-text="返回" fixed title="商户基本信息" left-arrow @click-left="onClickLeft">
      <!--通过插槽自定义导航栏右侧的内容 start-->
      <!--            <template #right>-->
      <!--                <van-icon name="wap-home-o" size="20" @click="onClickRight"/>-->
      <!--            </template>-->
      <!--通过插槽自定义导航栏右侧的内容 end-->
    </van-nav-bar>
    <!--导航栏 end-->
    <!--内容 start-->
    <div style="margin-top: 1.5rem">
      <div style="margin: 10px 0px">
        <van-notice-bar color="#1989fa" background="#ecf9ff">商户信息</van-notice-bar>
        <van-cell title="商户编号" :value="list.merchant_num" />
        <van-cell title="商户类型" :value="bb" />
        <van-cell title="商户营业执照名" :value="list.bse_lice_nm" />
      </div>
      <!--身份信息 start-->
      <div>
        <van-notice-bar color="#1989fa" background="#ecf9ff">法人信息</van-notice-bar>
        <van-cell title="法人姓名" :value="list.crp_nm" />
        <van-cell title="法人身份证号" :value="list.crp_id" />
      </div>
      <!--身份信息 end-->
      <!--我的银行卡 start-->
      <div style="margin-top: 10px">
        <van-notice-bar color="#1989fa" background="#ecf9ff">我的银行卡</van-notice-bar>
        <van-cell title="结算卡类型" :value="aa" />
        <van-cell title="结算卡开户支行" :value="list.settlement_open_subbank" />
        <van-cell title="结算账户" :value="list.settlement_account_name" />
        <van-cell title="结算账号" :value="list.settlement_card_number" />
       
      </div>
      <!--我的银行卡 end-->
    </div>
    <!--内容 end-->
  </div>
</template>

<script>
export default {
  name: "Merchantinfo", //商户信息
  data() {
    return {
      list: [],
      aa: "",
      bb: "",
    };
  },
  methods: {
    // 返回上一级
    onClickLeft() {
      // 返回商户信息
      this.$router.push("/MerchantManagement");
    },
    // 右侧icon跳转至商户首页
    // onClickRight() {
    //     // 返回商户首页
    //     this.$router.push('/MerchantHomepage');
    // },
    //初始化页面
    Basic() {
      this.$http
        .get("/wechat/api.agent.merchant/detailMerchant", {
          params: {
            merchant_id: this.$route.query.id,
          },
        })
        .then((response) => {
          this.list = response.data.data;
          this.Card();
          this.Cards();
        });
    },
    // 判断卡类型
    Card() {
      if (this.list.settlement_account_type == "01") {
        this.aa = "法人账户";
      } else if (this.list.settlement_account_type == "00") {
        this.aa = "对公账户";
      } else if (this.list.settlement_account_type == "02") {
        this.aa = "被授权人";
      }
    },
    //判断商户类型
    Cards() {
      if (this.list.merchant_type == "1") {
        this.bb = "个体";
      } else if (this.list.merchant_type == "2") {
        this.bb = "企业";
      } else if (this.list.merchant_type == "3") {
        this.bb = "小微";
      }
    },
  },
  mounted() {
    this.Basic();
  },
};
</script>

<style scoped>
.content_title {
  font-size: 18px;
}
</style>
